import { DataGridApi } from "@newview/ui";
import filterTool from "../util/filterTool";
import { ApiOption, IDecorator, MethodProp } from "../types";
import { NmisApi } from "../api/nmisApi";
import { QueryWrapper } from "@newview/infrastructure";
import { Decorator } from "./decorator";
import { runActions } from "../action";

export class DataGridDecorator extends Decorator implements IDecorator {
    public static NAME: string = "dataGrid";

    dataGridApi?: DataGridApi;
    // option 
    // gloablValue
    // source

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new DataGridDecorator();
    }

    isParseEvent() {
        return false;
    }

    parseButton(buttons: any[], isRow: boolean = false) {
        for (const btn of buttons) {
            if (!filterTool.isNull(btn.isShow)) {
                if (filterTool.isNull(btn.isShowExpression)) {
                    btn.isShowExpression = btn.isShow;
                }
                if (typeof btn.isShow == 'string' || typeof btn.isShow == 'boolean') {
                    btn.isShow = (row) => {
                        const data = isRow ? Object.assign(Object.assign({}, row), this.nmis!.openData) : Object.assign({}, this.nmis!.openData);
                        var result = filterTool.autoFilterValue(btn.isShowExpression, data);
                        return result;
                    }
                }

                if (btn.isShow.isMethod) {
                    const method = this.nmis!.getMethod(btn.isShow.methodName);
                    if (filterTool.isNull(method)) {
                        continue;
                    }
                    btn.isShow = (row) => {
                        const methodParam: MethodProp = {
                            sender: this.nmis,
                            param: {
                                row: row
                            }
                        }
                        return method(methodParam);
                    };
                }
            }

            if (!filterTool.isNull(btn.isEnable)) {
                if (filterTool.isNull(btn.isEnableExpression)) {
                    btn.isEnableExpression = btn.isEnable;
                }
                if (typeof btn.isEnable == 'string' || typeof btn.isEnable == 'boolean') {
                    btn.isEnable = (row) => {
                        const data = isRow ? Object.assign(Object.assign({}, row), this.nmis!.openData) : Object.assign({}, this.nmis!.openData);
                        return filterTool.autoFilterValue(btn.isEnableExpression, data);
                    }
                }

                if (btn.isEnable.isMethod) {
                    const method = this.nmis!.getMethod(btn.isEnable.methodName);
                    if (filterTool.isNull(method)) {
                        continue;
                    }
                    btn.isEnable = (row) => {
                        const methodParam: MethodProp = {
                            sender: this.nmis,
                            param: {
                                row: row
                            }
                        }
                        return method(methodParam);
                    };
                }
            }
        }
    }

    parseColumnMethod(column, key) {
        if (!filterTool.isNull(column[key])) {
            if (column[key].isMethod) {
                if (filterTool.isNull(column[key].methodName)) {
                    column[key] = undefined;
                } else {
                    const method = this.nmis!.getMethod(column[key].methodName);
                    if (filterTool.isNull(method)) {
                        return false;
                    }
                    return method;
                }
            }
        }
        return false;
    }

    /**
     * 1. 开始初始化
     */
    beforeInit() {
        const schema = this.nmis!.copySchemaNode;

        if (filterTool.isNull(schema.option)) {
            return;
        }

        // 解析toolbar
        if (schema.option.toolbars) {
            this.parseButton(schema.option.toolbars, false);
        }

        // 列format渲染方法
        for (const item of schema.option.columns) {
            // 渲染方法
            let formatMethod = this.parseColumnMethod(item, "format");
            if (formatMethod) {
                item["format"] = (h, parmas) => {
                    const methodParam: MethodProp = {
                        sender: this.nmis,
                        param: {
                            h: h,
                            row: parmas.row,
                            option: parmas
                        }
                    }
                    return formatMethod(methodParam);
                }
            }

            let changeMethod = this.parseColumnMethod(item, "change");
            if (changeMethod) {
                item["change"] = (row) => {
                    const methodParam: MethodProp = {
                        sender: this.nmis,
                        param: {
                            event: {
                                data: row
                            },
                            completeCallback: () => { }
                        }
                    }
                    return changeMethod(methodParam);
                }
            }

            if (!filterTool.isNull(item.rowButtons) && item.rowButtons.length > 0) {
                this.parseButton(item.rowButtons, true);
            }
        }

        // 解析事件
        if (filterTool.isNull(schema.option.event)) {
            schema.option.event = {};
        }

        for (const key in schema.on) {
            const event = schema.on[key];
            switch (key) {
                case "currentChange":
                    schema.option.event["currentChange"] = (currentRow, oldCurrentRow) => {
                        runActions(
                            event.actions,
                            { currentRow, oldCurrentRow, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "rowClick":
                    schema.option.event["rowClick"] = (rowData, index) => {
                        runActions(
                            event.actions,
                            { rowData, index, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "rowDblclick":
                    schema.option.event["rowDblclick"] = (rowData, index) => {
                        runActions(
                            event.actions,
                            { rowData, index, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "event_saveBefore":
                    schema.option.event["event_saveBefore"] = (datas: any[]) => {
                        runActions(
                            event.actions,
                            { datas, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "event_saveAfter":
                    schema.option.event["event_saveAfter"] = (datas: any[], result: any) => {
                        runActions(
                            event.actions,
                            { datas, result, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "event_deleteBefore":
                    schema.option.event["event_deleteBefore"] = (id: number) => {
                        runActions(
                            event.actions,
                            { id, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
                case "event_search":
                    schema.option.event["event_search"] = (datas: any) => {
                        runActions(
                            event.actions,
                            { datas, openData: this.nmis!.openData },
                            this.nmis!.componentIdMap,
                            this.nmis)
                    }
                    break;
            }
        }
    }

    /**
     * 2. 初始化完成
     */
    inited() {
        const schema = this.nmis!.copySchemaNode;
        this.dataGridApi = new DataGridApi(this.nmis!.$vue!);
        if (!filterTool.isNull(schema.source)) {
            schema.option.api = NmisApi.create(schema.source, this.nmis!.projectId, this.nmis!.childsysId, this.nmis!.devProd);
        }

        this.dataGridApi.setOption(schema.option);
        const gloablValue: any[] = schema["gloablValue"];

        if (!filterTool.isNull(gloablValue)) {
            for (const item of gloablValue) {
                this.dataGridApi.setGloablValue(item.key, filterTool.autoFilterValue(item.value, this.nmis!.openData), item.isOnlyAddSetValue)
            }
        }

        this.dataGridApi!.setGloablClick((toolbar, row, text) => {
            if (!filterTool.isNull(toolbar.on) && !filterTool.isNull(toolbar.on.click)) {
                runActions(
                    toolbar.on.click.actions,
                    Object.assign(this.fromJS(filterTool.isNull(row) ? {} : row), this.nmis!.openData),
                    this.nmis!.componentIdMap,
                    this.nmis)
                return false;
            }
            return true;
        });
    }

    /**
     * 3. 加载数据
     */
    async loadData(event?: any) {
        const source: ApiOption = this.nmis!.copySchemaNode.source;

        // 获取newData
        let newData = this.filterSourceData(event);

        // 获取数据
        this.dataGridApi!.loadData(async (option) => {
            if (filterTool.isNull(source.actionName) && filterTool.isNull(source.programkey) && !filterTool.isNull(source.controllerName) && !filterTool.isNull(source.proxyName)) {
                source.actionName = option.isPagination ? `getEntitiesPageDynamic?pageIndex=${option.page!}&pageSize=${option.pageSize!}` : 'getEntitiesDynamic';
            }

            const newScoure = filterTool.jsonClone(source);
            // 附加分页数据
            if (!filterTool.isNull(source.actionName) && option.isPagination) {
                newScoure.actionName += `?pageIndex=${option.page!}&pageSize=${option.pageSize!}`;
            }

            const result = await NmisApi.send(newScoure, newData, this.nmis!.projectId, this.nmis!.childsysId, this.nmis!.devProd);
            option.success(result.data);
        });
    }

    /**
     * 设置全局值
     * @param key 
     * @param value 
     * @param isOnlyAddSetValue 
     * @param event      
     */
    setGloablValue(key: string, value: string, isOnlyAddSetValue?: boolean, event?: any) {
        let openData = this.nmis!.openData;
        if (!filterTool.isNull(event)) {
            openData = Object.assign(filterTool.jsonClone(event), openData)
        }

        this.dataGridApi!.setGloablValue(key, filterTool.autoFilterValue(value, openData), isOnlyAddSetValue);
    }

}